module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.routes), function(route) {
    return _c('div', {
      key: route.name
    }, [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_vm._v(_vm._s(route.name))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d70b73f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/showcase/Home.vue
// module id = 56
// module chunks = 0